<template>
  <router-view v-if="isRouterAlive" :class="langClass"></router-view>
</template>
<script>
    export default {
        provide() {
            return {
                reload: this.reload
            }
        },
        computed:{
            langClass(){
                return this.$i18n.locale === 'en'?'en-lang':'zh-lang'
            }
        },
        data() {
            return {
                isRouterAlive: true
            }
        },
        methods: {
            reload() {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            }
        },
        mounted: function () {
            const lang = localStorage.getItem('lang');
            if (lang) {
                this.$i18n.locale = lang;
            }
        }
    };
</script>
<style>
  @import './assets/css/main.css';
  @import './assets/css/color-dark.css'; /*深色主题*/
</style>
